import ls from 'local-storage';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { COMMON_LOCAL_STORAGE_CACHE_KEY } from '../constants/localStorageConstants';
import {
  HOTELS_CACHE_VERSION,
  COMMON_CACHE_VERSION,
} from '../constants/cacheConstants';
import loadHotelsCacheThunk from './loadHotelsCacheThunk';
import loadCommonCacheThunk from './loadCommonCacheThunk';
import { getHotelsCacheKey, getIsValidCache } from '../utils/cacheUtils';

const loadCacheThunk = (taxonomy = '') => (dispatch, getState) => {
  const state = getState();
  const locale = getActiveLocaleSelector(state);
  const hotelsCache = ls.get(getHotelsCacheKey(locale, taxonomy));
  const commonCache = ls.get(COMMON_LOCAL_STORAGE_CACHE_KEY);

  const isHotelsCacheSupported = getIsValidCache(hotelsCache, HOTELS_CACHE_VERSION, state);
  const isCommonCacheSupported = getIsValidCache(commonCache, COMMON_CACHE_VERSION, state);

  if (isHotelsCacheSupported && isCommonCacheSupported) {
    const hotelsCacheTimestamp = hotelsCache?.timestamp || 0;
    const commonCacheTimestamp = commonCache?.timestamp || 0;

    if (hotelsCacheTimestamp >= commonCacheTimestamp) {
      dispatch(loadHotelsCacheThunk(locale, taxonomy));
    } else {
      dispatch(loadCommonCacheThunk(taxonomy));
    }
  } else if (isHotelsCacheSupported) {
    dispatch(loadHotelsCacheThunk(locale, taxonomy));
  } else if (isCommonCacheSupported) {
    dispatch(loadCommonCacheThunk(taxonomy));
  }
};

export default loadCacheThunk;
